import { Timestamp } from 'google-protobuf/google/protobuf/timestamp_pb';

type TimestampObject = Timestamp.AsObject | undefined;

export function formatFreezeMoney(amount: number, currency: string) {
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currency || 'USD'
  }).format(amount / 100);
}

/** An amount billing-manager priced, or undefined when it sent none: no currency means it could not price it. */
export function knownFreezeMoney(amount: number, currency: string) {
  return currency ? formatFreezeMoney(amount, currency) : undefined;
}

export function formatFreezeDay(date: Date) {
  return new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' }).format(date);
}

export function formatFreezeDate(timestamp: TimestampObject) {
  if (!timestamp) return 'Not available';
  const seconds = Number(timestamp.seconds);
  if (!Number.isFinite(seconds)) return 'Not available';
  return formatFreezeDay(new Date(seconds * 1000));
}

export function getFreezeErrorMessage(error: unknown) {
  if (error instanceof Error && error.message) return error.message;
  return 'Something went wrong. Please try again.';
}
